module.exports = __webpack_public_path__ + "static/media/lobby.5a513f47.jpg";